import React, { FC } from 'react';
import styles from './entity_chart_components.module.scss';

export const EntityChartContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export const EntityChartBlock: FC = ({ children }) => (
  <div className={styles.block}>{children}</div>
);

export const EntityChartItem: FC = ({ children }) => (
  <div className={styles.item}>{children}</div>
);
